import React, { FC, PropsWithChildren, ReactElement, ReactNode, useState } from 'react';

export interface IAlert {
  href?: string;
  link?: ReactNode;
  title?: string;
  message?: ReactNode;
  actions?: ReactNode;
  error?: boolean;
  info?: boolean;
}

interface AlertContextType {
  alerts: IAlert[];
  setAlerts: (alerts: IAlert[]) => void;
}

export const AlertContext = React.createContext<AlertContextType>({
  alerts: [],
  setAlerts: () => undefined
});

const AlertProvider: FC<PropsWithChildren> = ({ children }): ReactElement => {
  const [alerts, setAlerts] = useState<IAlert[]>([]);

  const contextValue = {
    alerts,
    setAlerts
  };

  return <AlertContext.Provider value={contextValue}>{children}</AlertContext.Provider>;
};

export default AlertProvider;
